import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './DevisPage.css';

const DevisPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    email: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid = () => {
    return (
      formData.email.trim() !== '' &&
      isValidEmail(formData.email)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    console.log('Demande de devis:', formData);
    
    try {
      // Envoi vers l'API backend
      const response = await fetch('/api/send-devis', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        // Appeler la fonction de conversion Google Ads
        if (window.gtag_report_conversion) {
          window.gtag_report_conversion();
        }
        // Appeler la fonction de conversion LinkedIn Ads
        if (window.lintrk) {
          window.lintrk('track', { conversion_id: 25396298 });
        }
        setSubmitted(true);
      } else {
        const errorData = await response.json();
        console.error('Erreur:', errorData);
        alert('Erreur lors de l\'envoi du formulaire. Veuillez réessayer.');
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
      alert('Erreur de connexion. Veuillez vérifier votre connexion internet.');
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="devis-page">
        <div className="container">
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Demande envoyée avec succès !</h2>
            <p>Nous vous recontacterons dans les 24 heures.</p>
            <button className="back-button" onClick={() => navigate('/')}>
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="devis-page">
      <div className="container">
        <button className="back-link" onClick={() => navigate('/')}>
          ← Retour à l'accueil
        </button>
        
        <h1 className="page-title">Demander un devis personnalisé</h1>
        <p className="page-subtitle">
          Remplissez ce formulaire pour recevoir une estimation adaptée à vos besoins
        </p>

        <form className="devis-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Adresse mail *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="votre@email.com"
              required
            />
          </div>

          <button type="submit" className="submit-button" disabled={!isFormValid() || isSubmitting}>
            {isSubmitting ? 'Envoi en cours...' : 'Envoyer la demande de devis'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DevisPage;
